/*
  Happy Ganga - marquee top-up
  sections/hg-marquee.liquid

  The section ships TWO copies of the list so a seamless loop works with no
  JavaScript at all. That is enough whenever one copy is already wider than
  the viewport, which is the normal case. It is NOT enough for a short row on
  a wide screen - three badges on a 2560px monitor leave a visible gap that
  sweeps across every cycle, which is the classic broken marquee.

  So this measures one copy against the viewport and clones until the track is
  wider than the container plus one whole copy, then tells CSS how many copies
  there are. The animation shifts by exactly 100% / copies, which lands copy 2
  where copy 1 began for ANY number of copies - so nothing here has to know
  about the duration, the direction, or the gap.

  Everything it does is a top-up: with the script blocked, two copies still
  loop correctly at the widths where two copies suffice.

  THE HOOK IS data-hg-marquee-LOOP. hg-motion.js has its own, older marquee
  routine bound to the bare data-hg-marquee, written for the category rail
  where that attribute sits ON the track and the row is its first child. This
  section nests view > track > lists, so that routine cloned the entire view
  and stacked a second row under the first. The two must not share a name.
*/
(function () {
  'use strict';

  var MAX_COPIES = 24; // a runaway guard, not a design limit

  function setup(root) {
    var view = root.querySelector('.hg-marquee__view');
    var track = root.querySelector('.hg-marquee__track');
    if (!view || !track) return;

    var first = track.querySelector('.hg-marquee__list');
    if (!first) return;

    // Reduced motion turns the row into a plain scrollable strip, so cloning
    // would only hand a screen reader the same claims several times over.
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      track.style.removeProperty('--hg-marquee-copies');
      return;
    }

    // Measure ONE copy. offsetWidth includes the trailing gap padding, which
    // is what makes the join between copies match the gap inside them.
    var setWidth = first.offsetWidth;
    if (!setWidth) return;

    var needed = Math.ceil(view.offsetWidth / setWidth) + 1;
    if (needed < 2) needed = 2;
    if (needed > MAX_COPIES) needed = MAX_COPIES;

    var lists = track.querySelectorAll('.hg-marquee__list');
    var have = lists.length;

    if (have < needed) {
      var frag = document.createDocumentFragment();
      for (var i = have; i < needed; i++) {
        var clone = first.cloneNode(true);
        // Clones repeat content that is already announced once. Hide them,
        // and strip any ids so the duplicates cannot collide.
        clone.setAttribute('aria-hidden', 'true');
        clone.querySelectorAll('[id]').forEach(function (el) {
          el.removeAttribute('id');
        });
        frag.appendChild(clone);
      }
      track.appendChild(frag);
    } else if (have > needed) {
      // Never remove the two the section rendered - they are the no-JS path.
      for (var j = have - 1; j >= Math.max(needed, 2); j--) {
        track.removeChild(lists[j]);
      }
    }

    track.style.setProperty(
      '--hg-marquee-copies',
      String(track.querySelectorAll('.hg-marquee__list').length)
    );
  }

  function setupAll(scope) {
    (scope || document).querySelectorAll('[data-hg-marquee-loop]').forEach(setup);
  }

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn, { once: true });
    } else {
      fn();
    }
  }

  ready(function () {
    setupAll();

    /*
      Re-measure on resize. Width only: mobile browsers fire resize when the
      address bar collapses, and re-cloning the row mid-scroll for a height
      change would restart the animation for no reason.
    */
    var lastWidth = window.innerWidth;
    var timer = null;
    window.addEventListener(
      'resize',
      function () {
        if (window.innerWidth === lastWidth) return;
        lastWidth = window.innerWidth;
        clearTimeout(timer);
        timer = setTimeout(function () {
          setupAll();
        }, 200);
      },
      { passive: true }
    );

    /*
      Web fonts land after first paint and change every label's width, so a
      row measured against the fallback face would be short by the difference.
    */
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function () {
        setupAll();
      });
    }

    // Theme editor: a section re-rendered on edit arrives with two copies.
    document.addEventListener('shopify:section:load', function (e) {
      setupAll(e.target);
    });
  });
})();
